import axios from "axios";
import { useSelector } from "react-redux";
import { store } from "../state/store";

axios.defaults.withCredentials = false;

const axiosInstance = axios.create({
    // baseURL: "http://170.187.238.121:8000",
    baseURL:"https://apidms.mobiginie.com",
    crossDomain: false,
});

// Interceptor to update headers with the latest token
const updateTokenInterceptor = axiosInstance.interceptors.request.use(
    (config) => {
        const token = store.getState()?.root?.auth?.token;
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Function to remove the token interceptor
const removeTokenInterceptor = () => {
    axiosInstance.interceptors.request.eject(updateTokenInterceptor);
};

export { axiosInstance, removeTokenInterceptor };
